// modules
import { createAction } from 'redux-actions'

// actions
export const setCompanyGamificationAchievements = createAction(
  'SET_COMPANY_GAMIFICATION_ACHIEVEMENTS'
)
export const setCompanyGamificationTasks = createAction(
  'SET_COMPANY_GAMIFICATION_TASKS'
)

export const setCompanyGamificationShopItems = createAction(
  'SET_COMPANY_GAMIFICATION_SHOP_ITEMS'
)
export const setCompanyGamificationVisibility = createAction(
  'SET_COMPANY_GAMIFICATION_VISIBILITY'
)

export const setCompanyGamificationRedemptionList = createAction(
  'SET_COMPANY_GAMIFICATION_REDEMPTION_LIST'
)

export const setGamificationTableLoading = createAction(
  'SET_GAMIFICATION_TABLE_LOADING'
)

export const setRedemptionItemHistory = createAction(
  'SET_REDEMPTION_ITEM_HISTORY'
)
export const clearRedemptionItemHistory = createAction(
  'CLEAR_REDEMPTION_ITEM_HISTORY'
)

export const setRedemptionBadgeCount = createAction(
  'SET_REDEMPTION_BADGE_COUNT'
)
